

import pedalImage from "../../../static/images/distant_bass_suite/pedal-frame.webp"
import { Box, Typography, Grid } from "@mui/material";

const PrePredals = () => {
  return <Box sx={{ p: 5, background: "radial-gradient(circle, #eee 0%,#aaa 100%)", color: "#000", justifyContent: "center", alignItems: "center" }} >
    <Box sx={{ width: "100%", justifyContent: "center" }}>
      <Typography variant="h3" sx={{ textAlign: "center" }}>Pedals</Typography>
    </Box>
    <Grid container justifyContent={"center"}>
      <Grid item xs={12} md={10}>
        <img src={pedalImage} width="100%" alt="BassSuite - Distant pedals" />
      </Grid>

    </Grid>
    <Grid container justifyContent={"center"}>
      <Grid item xs={12} md={6} lg={4}>
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Clank Designer:</b> Shape your bass sound with this multiband processor. Dial in exactly the right amount of clank, body, and grind, then smooth out the high end with the Tame control.</Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Tube Overdrive:</b> Add tube warmth to your bass with this high-voltage, 12AX7-based overdrive pedal. Blend the driven and clean signals to preserve low-end weight, then move from subtle saturation to an aggressive, harmonically rich grind with the Drive, Tone, and Level controls.</Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: "left" }}><b>Bass Equalizer:</b> Fine-tune the balance of your bass sound before it reaches the amplifiers. This six-band analog EQ is voiced specifically for bass signals, giving you precise control over the frequencies that matter most.</Typography>

      </Grid>
    </Grid>

  </Box>
}

export default PrePredals;
